export const isSet = (s: string|undefined|null) => s !== '' && s !== undefined && s !== null


export function checkValidKey<T>(record: Record<string, T> | undefined, key: string | undefined): string | undefined {
    if(record == undefined || key == undefined) {
        return undefined
    }

    if(!(key in record)) {
        return undefined
    }

    return key
}

export const mapRecord = <V, R>(record: Record<string,V>, callback: (key: string, value: V) => R, preprocess?: (arg: [string, V][]) => [string, V][]): R[] => {
    let entries = Object.entries(record)
    if(preprocess) {
        entries = preprocess(entries)
    }
    return entries.map(([k, v]) => callback(k, v))
}

export const keyToIndex = <V,>(record: Record<string,V> | undefined, key: string | undefined, allowEmpty: boolean = false): number => {
    if(record == undefined || key == undefined || key == '') {
        return 0
    }
    const keys = Object.keys(record) as Array<string>
    keys.sort()
    return keys.indexOf(key) + (allowEmpty ? 1 : 0)
}

export const indexToKey = <V,>(record: Record<string,V> | undefined, index: number, allowEmpty: boolean = false): string => {
    if(record == undefined) {
        return undefined!
    }
    if(allowEmpty)
    {
        if(index == 0) {
            return ''
        }
        index = index - 1
    }
    const keys = Object.keys(record) as Array<string>
    keys.sort()
    return keys[index]
}
